import firebase from "firebase/app";
import { tUser, validate } from "tmt_api/src/types/types.validator";

export const documentUser = (id: string): firebase.firestore.DocumentReference<tUser> =>
  firebase
    .firestore()
    .collection("users")
    .doc(id)
    .withConverter<tUser>({
      toFirestore: (data) => data,
      fromFirestore: (snapshot) => validate("tUser")(snapshot.data()),
    });

export const queryUser = (params: { companyRefPath?: string }): firebase.firestore.Query<tUser> => {
  let collectionRef: firebase.firestore.Query = firebase.firestore().collection("users");

  if (params.companyRefPath) collectionRef = collectionRef.where("companyRefPath", "==", params.companyRefPath);

  return collectionRef.withConverter<tUser>({
    toFirestore: (data) => data,
    fromFirestore: (snapshot) => validate("tUser")(snapshot.data()),
  });
};
